module.exports = __webpack_public_path__ + "static/media/blockchain_cube_empty.966f1ec3.svg";